import cn from 'classnames';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

import CheckoutAddressField from '../../../../../TextField/CheckoutAddressField/CheckoutAddressField';

import styles from './AddressFields.module.sass';

//Модльные окна "Куда доставить заказ"
const AddressFields: FC = () => {
  const { control } = useFormContext();
  return (
    <div className={styles.modal}>
      <div className={cn(styles.group, styles.group1)}>
        <Controller
          control={control}
          name="delivery_address"
          rules={{
            required: 'Некорректный формат адрес доставки',
          }}
          render={({ field: { onChange, value } }) => (
            <CheckoutAddressField
              required
              onChange={onChange}
              value={value}
              className="Checkout_div_left_part2_delivery_deliv_group_group2_inp"
              label="Укажите адрес доставки"
              name="delivery_address"
            />
          )}
        />
      </div>
      <div className={cn(styles.group, styles.group2)}>
        <div className={styles.wrapper}>
          <Controller
            control={control}
            name="other_recipient_name"
            rules={{
              required: 'Некорректный формат ФИО получателя',
            }}
            render={({ field: { onChange, value } }) => (
              <CheckoutAddressField
                required
                onChange={onChange}
                value={value}
                className="add-address-modal_group2_inp"
                label="ФИО получателя"
                name="other_recipient_name"
              />
            )}
          />
          <Controller
            control={control}
            name="other_recipient_phone"
            rules={{
              required: 'Некорректный формат телефона',
              pattern: {
                value: /^(\+7|8)\s\d{3}\s\d{3}\s\d{2}\s\d{2}$/,
                message: 'Некорректный формат телефона',
              },
            }}
            render={({ field: { onChange, value } }) => (
              <InputMask
                mask="+7 999 999 99 99"
                maskChar={null}
                maskPlaceholder={null}
                value={value}
                onChange={onChange}
                inputMode="tel"
                width={100}
              >
                <CheckoutAddressField
                  className="add-address-modal_group2_inp"
                  label="Телефон получателя"
                  name="other_recipient_phone"
                />
              </InputMask>
            )}
          />
        </div>
      </div>

      <div className={cn(styles.group, styles.group3)}>
        <Controller
          control={control}
          name="delivery_courier_comment"
          render={({ field: { onChange, value } }) => (
            <CheckoutAddressField
              onChange={onChange}
              value={value}
              className="add-address-modal_group3_inp"
              label="Комментарий курьеру"
              name="delivery_courier_comment"
            />
          )}
        />
      </div>
    </div>
  );
};

export default AddressFields;
